export default __webpack_public_path__ + "static/media/2314.bf952637.png";